var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userOrb"},[(!_vm.showImage)?_c('h5',[_vm._v(" "+_vm._s(_vm.defaultValue)+" ")]):_vm._e(),(_vm.showImage)?_c('img',{attrs:{"width":"100%","height":"100%","src":_vm.s3Url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }